import { render, staticRenderFns } from "./UsuarioEmpresa.vue?vue&type=template&id=c9365552"
import script from "./UsuarioEmpresa.vue?vue&type=script&lang=js"
export * from "./UsuarioEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports